import { LegalShell as Layout } from "@/components/connect/LegalShell";
import { Link } from "react-router-dom";
import { SEOHead } from "@/components/seo/SEOHead";
import { PAGE_SEO, getCanonicalUrl, getBreadcrumbSchema } from "@/config/seo";
import { TermsContent } from "@/components/connect/TermsContent";

/**
 * Public marketing Terms page.
 *
 * Single source of truth: renders the same `<TermsContent />` used by the
 * authenticated portal page (`ConnectTermsPage`) and the in-app `TermsDialog`.
 * This eliminates drift between the three surfaces - update one file, all
 * three update.
 */
const TermsOfService = () => {
  return (
    <Layout>
      <SEOHead
        title={PAGE_SEO.terms.title}
        description={PAGE_SEO.terms.description}
        keywords={PAGE_SEO.terms.keywords}
        canonicalUrl={getCanonicalUrl('/legal/terms')}
        structuredData={getBreadcrumbSchema([
          { name: 'Home', url: 'https://elefa.tel/' },
          { name: 'Terms of Service', url: 'https://elefa.tel/legal/terms' },
        ])}
      />
      <section className="py-16">
        <div className="container">
          <div className="mx-auto max-w-4xl">
            <nav className="mb-6 flex items-center gap-2 text-sm text-muted-foreground">
              <Link to="/" className="hover:text-primary transition-colors">Home</Link>
              <span>/</span>
              <span className="text-foreground font-medium">Terms of Service</span>
            </nav>

            <TermsContent />

            <div className="mt-8 flex flex-wrap gap-4 text-sm">
              <Link to="/legal/privacy" className="text-primary hover:underline">Privacy Policy</Link>
              <span className="text-muted-foreground">•</span>
              <Link to="/legal/fair-use" className="text-primary hover:underline">Fair Use Policy</Link>
              <span className="text-muted-foreground">•</span>
              <Link to="/legal/complaints" className="text-primary hover:underline">Complaints Policy</Link>
              <span className="text-muted-foreground">•</span>
              <Link to="/regulatory" className="text-primary hover:underline">Regulatory Information</Link>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default TermsOfService;
